import { IllegalArgumentError } from "@archipad-js/core/error";
import { BugEntity } from "./BugEntity";
import { BugAnnotationGeneratedEntity } from "./generated/BugAnnotationGeneratedEntity";

export abstract class BugAnnotationEntity extends BugAnnotationGeneratedEntity {
    public get parentAnnotatedEntity(): BugEntity {
        return this.bug;
    }

    public set parentAnnotatedEntity(parentAnnotatedEntity: BugEntity) {
        if (!parentAnnotatedEntity) {
            throw new IllegalArgumentError("cannot be null nor undefined", "parentAnnotatedEntity");
        }
        this.bug = parentAnnotatedEntity;
    }
}
